export const MAX_FEATHER = 1000;
export const FEATHER_HANDLE_SCALE = 0.11;
